// src/schemas/component-defaults.ts
import { Type } from "@sinclair/typebox";

// src/schemas/components/text.ts
import {
  TextPropsSchema,
  TextRunSchema
} from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/image.ts
import { PptxImagePropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/shape.ts
import {
  ShapePropsSchema,
  ShapeTypeSchema,
  TextSegmentSchema,
  GradientStopSchema,
  GradientFillSchema,
  PatternFillSchema,
  PATTERN_FILL_PRESETS
} from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/table.ts
import { PptxTablePropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/highcharts.ts
import { PptxHighchartsPropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/chart.ts
import { PptxChartPropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/component-defaults.ts
var TextComponentDefaultsSchema = Type.Partial(TextPropsSchema);
var ImageComponentDefaultsSchema = Type.Partial(PptxImagePropsSchema);
var ShapeComponentDefaultsSchema = Type.Partial(ShapePropsSchema);
var TableComponentDefaultsSchema = Type.Partial(PptxTablePropsSchema);
var HighchartsComponentDefaultsSchema = Type.Partial(
  PptxHighchartsPropsSchema
);
var ChartComponentDefaultsSchema = Type.Partial(PptxChartPropsSchema);
var PptxComponentDefaultsSchema = Type.Object(
  {
    text: Type.Optional(TextComponentDefaultsSchema),
    image: Type.Optional(ImageComponentDefaultsSchema),
    shape: Type.Optional(ShapeComponentDefaultsSchema),
    table: Type.Optional(TableComponentDefaultsSchema),
    highcharts: Type.Optional(HighchartsComponentDefaultsSchema),
    chart: Type.Optional(ChartComponentDefaultsSchema)
  },
  { additionalProperties: true }
);

export {
  TextPropsSchema,
  TextRunSchema,
  PptxImagePropsSchema,
  ShapePropsSchema,
  ShapeTypeSchema,
  TextSegmentSchema,
  GradientStopSchema,
  GradientFillSchema,
  PatternFillSchema,
  PATTERN_FILL_PRESETS,
  PptxTablePropsSchema,
  PptxHighchartsPropsSchema,
  PptxChartPropsSchema,
  TextComponentDefaultsSchema,
  ImageComponentDefaultsSchema,
  ShapeComponentDefaultsSchema,
  TableComponentDefaultsSchema,
  HighchartsComponentDefaultsSchema,
  ChartComponentDefaultsSchema,
  PptxComponentDefaultsSchema
};
//# sourceMappingURL=chunk-Z6NUHS34.js.map